import { Color, Display, Box, Text } from '@gousto-internal/citrus-react'
import React from 'react'

import type {
  DashboardHeaderTag,
  DashboardHeaderTagType,
} from '@library/api-customer-engagement-experience'

type HeaderTagProps = {
  data: DashboardHeaderTag
}

const TEXT_COLOR: Record<DashboardHeaderTagType, Color> = {
  positive: Color.Success_900,
  neutral: Color.ColdGrey_600,
}

const FormattedSubtitleText = ({ text }: { text: string }) => (
  <>
    {text
      .split(/(\*\*[^*]+\*\*)/g)
      .map((part, index) =>
        part.startsWith('**') && part.endsWith('**') ? (
          <strong key={index}>{part.slice(2, -2)}</strong>
        ) : (
          part
        ),
      )}
  </>
)

export const HeaderTag = ({ data }: HeaderTagProps) => (
  <Box
    bg={Color.White}
    data-testid="header-tag"
    display={Display.InlineFlex}
    paddingH={2}
    paddingV={0.5}
    style={{ borderRadius: '4px' }}
  >
    <Text color={TEXT_COLOR[data.type]} size={4}>
      <FormattedSubtitleText text={data.text} />
    </Text>
  </Box>
)
